'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alignment = exports.Font = exports.Fill = exports.Border = exports.Style = undefined;

var _xmlStyle = require('./xmlStyle');

let Style = exports.Style = class Style {

  constructor() {
    this.applyBorder = false;
    this.applyFill = false;
    this.applyFont = false;
    this.applyAlignment = false;
    this.namedStyleIndex = null;

    this.border = new Border({});
    this.fill = new Fill({});
    this.font = new Font({});
    this.align = new Alignment({});
  }
  makeXStyleElements() {
    const xFont = new _xmlStyle.Xfont({
      sz: this.font.size,
      name: this.font.name,
      family: this.font.family,
      charset: this.font.charset,
      color: this.font.color,
      b: this.font.bold,
      i: this.font.italic,
      u: this.font.underline
    });
    const xFill = new _xmlStyle.Xfill({
      patternFill: new _xmlStyle.XpatternFill({
        patternType: this.fill.patternType,
        fgColor: this.fill.fgColor,
        bgColor: this.fill.bgColor
      })
    });
    const xBorder = new _xmlStyle.Xborder({
      left: { style: this.border.left, color: this.border.leftColor },
      right: { style: this.border.right, color: this.border.rightColor },
      top: { style: this.border.top, color: this.border.topColor },
      bottom: { style: this.border.bottom, color: this.border.bottomColor }
    });
    const xXf = new _xmlStyle.Xxf({
      numFmtId: 0,
      applyBorder: this.applyBorder,
      applyFill: this.applyFill,
      applyFont: this.applyFont,
      applyAlignment: this.applyAlignment
    });

    xXf.alignment = new _xmlStyle.Xalignment({
      horizontal: this.align.h,
      indent: this.align.indent,
      shrinkToFit: this.align.shrinkToFit,
      textRotation: this.align.textRotation,
      vertical: this.align.v,
      wrapText: this.align.wrapText
    });

    if (this.namedStyleIndex !== null) {
      xXf.xfId = this.namedStyleIndex;
    }

    return { xFont: xFont, xFill: xFill, xBorder: xBorder, xXf: xXf };
  }
};
let Border = exports.Border = class Border {

  constructor(_ref) {
    var _ref$left = _ref.left;
    let left = _ref$left === undefined ? 'none' : _ref$left;
    var _ref$right = _ref.right;
    let right = _ref$right === undefined ? 'none' : _ref$right;
    var _ref$top = _ref.top;
    let top = _ref$top === undefined ? 'none' : _ref$top;
    var _ref$bottom = _ref.bottom;
    let bottom = _ref$bottom === undefined ? 'none' : _ref$bottom;
    this.leftColor = '';
    this.rightColor = '';
    this.topColor = '';
    this.bottomColor = '';

    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
  }
};
let Fill = exports.Fill = class Fill {
  constructor(_ref2) {
    var _ref2$patternType = _ref2.patternType;
    let patternType = _ref2$patternType === undefined ? 'none' : _ref2$patternType;
    var _ref2$fgColor = _ref2.fgColor;
    let fgColor = _ref2$fgColor === undefined ? 'FFFFFFFF' : _ref2$fgColor;
    var _ref2$bgColor = _ref2.bgColor;
    let bgColor = _ref2$bgColor === undefined ? '00000000' : _ref2$bgColor;

    this.patternType = patternType;
    this.fgColor = fgColor;
    this.bgColor = bgColor;
  }
};
let Font = exports.Font = class Font {

  constructor(_ref3) {
    var _ref3$size = _ref3.size;
    let size = _ref3$size === undefined ? 12 : _ref3$size;
    var _ref3$name = _ref3.name;
    let name = _ref3$name === undefined ? 'Verdana' : _ref3$name;
    this.family = 0;
    this.charset = 0;
    this.color = '';
    this.bold = false;
    this.italic = false;
    this.underline = false;

    this.size = size;
    this.name = name;
  }
};
let Alignment = exports.Alignment = class Alignment {

  constructor(_ref4) {
    var _ref4$h = _ref4.h;
    let h = _ref4$h === undefined ? 'general' : _ref4$h;
    var _ref4$v = _ref4.v;
    let v = _ref4$v === undefined ? 'bottom' : _ref4$v;
    this.indent = 0;
    this.shrinkToFit = false;
    this.textRotation = 0;
    this.wrapText = false;

    this.h = h;
    this.v = v;
  }
};